module.exports = __webpack_public_path__ + "img/gift.dcf4152f.svg";